import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Crosshair, X } from "lucide-react";
import { FleetMap } from "@/components/map/FleetMap";
import { VehicleList } from "@/components/VehicleList";
import { VehicleInfoPanel } from "@/components/VehicleInfoPanel";
import { Empty } from "@/components/common";
import { useFleet } from "@/context/FleetContext";
import { cn } from "@/lib/utils";

export default function LiveTracking() {
  const { vehicles, byId, connected } = useFleet();
  const [params, setParams] = useSearchParams();
  const [sel, setSel] = useState(params.get("v"));
  const [cluster, setCluster] = useState(true);
  const [follow, setFollow] = useState(false);
  const v = sel ? byId[sel] : null;

  useEffect(() => {
    if (sel) setParams({ v: sel }, { replace: true });
    else setParams({}, { replace: true });
  }, [sel, setParams]);

  return (
    <div className="flex flex-col lg:grid lg:h-[calc(100vh-64px)] lg:grid-cols-[300px_1fr_340px] xl:grid-cols-[320px_1fr_360px]" data-testid="live-tracking-page">
      <aside className="order-3 border-r border-border bg-card/40 lg:order-1 lg:flex lg:min-h-0 lg:flex-col">
        <div className="flex items-center justify-between px-4 pt-4">
          <div><div className="gt-eyebrow">Live Tracking</div><div className="text-lg font-extrabold">Armada</div></div>
          <span className={cn("flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-bold", connected ? "border-emerald-500/40 text-emerald-500" : "border-red-500/40 text-red-500")} data-testid="live-ws-status">
            <span className={cn("h-1.5 w-1.5 rounded-full", connected ? "bg-emerald-500 gt-blink" : "bg-red-500")} />{connected ? "REALTIME" : "OFFLINE"}
          </span>
        </div>
        <VehicleList vehicles={vehicles} selectedId={sel} onSelect={setSel} className="max-h-[520px] lg:max-h-none lg:flex-1" />
      </aside>
      <section className="relative order-1 h-[52vh] lg:order-2 lg:h-auto">
        <FleetMap vehicles={vehicles} selectedId={sel} onSelect={setSel} cluster={cluster} onToggleCluster={() => setCluster((c) => !c)} follow={follow} className="h-full" testId="live-map" />
        {v && (
          <button onClick={() => setFollow((f) => !f)} data-testid="live-follow-toggle"
            className={cn("absolute left-3 top-3 z-[500] flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-bold backdrop-blur",
              follow ? "border-primary bg-primary text-primary-foreground" : "border-border bg-card/90")}>
            <Crosshair className="h-3.5 w-3.5" /> {follow ? "Mengikuti" : "Ikuti kendaraan"}
          </button>
        )}
      </section>
      <aside className="order-2 border-l border-border bg-card/40 lg:order-3 lg:min-h-0 lg:overflow-y-auto gt-scroll" data-testid="live-detail-panel">
        {v ? (
          <VehicleInfoPanel v={v} onClose={() => setSel(null)} onLocate={() => setFollow(true)} />
        ) : (
          <div className="hidden h-full lg:block">
            <Empty icon={X} title="Belum ada kendaraan dipilih" text="Pilih kendaraan dari daftar atau klik marker di peta untuk melihat telemetri realtime." className="h-full" />
          </div>
        )}
      </aside>
    </div>
  );
}
